import * as React from 'react';
import { connect } from 'react-redux';
import { fetchSeller, editSeller } from '../../actions/sellersActions';
import Cleave from 'cleave.js/react';
import PropTypes from 'prop-types';
import { selectSellerMerged } from '../../helper/sellerMergedSelector';


class Liquidacion extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            didEdit: false
        };
        this.diasCorteInputRef = React.createRef();
    };

    componentDidMount() {
        if (this.diasCorteInputRef.current?.element) {
            this.diasCorteInputRef.current.element.focus();
        }
    }

    myChangeHandler = (event) => {
        this.setState({
            didEdit: true
        })

        let seller = this.props.seller;
        seller[event.target.name] = event.target.value;
        this.props.editSeller(seller);
    }

    render() {
        let { seller } = this.props;

        return (
            <div className="tab-pane active" name="datos" id="home2" role="tabpanel">
                <section className="profile-section">
                    <header className="profile-section__head">
                        <span className="profile-section__icon" aria-hidden="true"><i className="mdi mdi-chart-bar" /></span>
                        <div>
                            <h5 className="profile-section__title">Plazos de liquidación</h5>
                            <p className="profile-section__hint">Días de corte y de pago del seller.</p>
                        </div>
                    </header>
                    <div className="row g-3">
                        <div className="form-group col-md-6">
                            <label htmlFor="diasCorteId"> Días de corte </label>
                            <Cleave
                                id="diasCorteId"
                                className="form-control"
                                name="diasCorte"
                                value={seller.diasCorte || ""}
                                options={{ blocks: [2], numericOnly: true }}
                                onChange={this.myChangeHandler}
                                ref={this.diasCorteInputRef}
                            />
                        </div>

                        <div className="form-group col-md-6">
                            <label htmlFor="diasPlazoPagoId"> Días de pago </label>
                            <Cleave id="diasPlazoPagoId" className="form-control" name="diasPlazoPago" value={seller.diasPlazoPago || ""}
                                options={{ blocks: [2], numericOnly: true }}
                                onChange={this.myChangeHandler} />
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}
Liquidacion.propTypes = {
    // Redux props
    seller: PropTypes.shape({
        diasCorte: PropTypes.number,
        diasPlazoPago: PropTypes.number
    }),
    // Actions props
    editSeller: PropTypes.func
}

const mapStateToProps = state => ({
    seller: selectSellerMerged(state),
    tipoUsuario: state.general.tipoUsuario,
});
export default connect(mapStateToProps, { fetchSeller, editSeller })(Liquidacion);